module.exports = __webpack_public_path__ + "img/ThaiQRpayments.bd719649.png";